const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

const hotjarScript = `(function(h,o,t,j,a,r){
  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
  h._hjSettings={hjid:1343208,hjsv:6};
  a=o.getElementsByTagName('head')[0];
  r=o.createElement('script');r.async=1;
  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
  a.appendChild(r);
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`

exports.onClientEntry = () => {
  const hotjarInit = () => {
    const script = document.createElement('script')
    script.id = 'gatsby-plugin-hotjar'
    const inlineScript = document.createTextNode(hotjarScript)
    script.appendChild(inlineScript)
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  window.removeEventListener(cookieAcceptEventName, hotjarInit)
  window.addEventListener(cookieAcceptEventName, hotjarInit, {
    once: true,
  })

  if (hasAcceptedCookies('analytics')) {
    hotjarInit()
  }
}
